export default __webpack_public_path__ + "static/media/file-medical.f471cd53.svg";